import React from "react";
import Select from "react-select";

const StatusFilterDropdown = ({ options, selectedOptions, onChange }) => {
  const handleChange = (selected) => {
    onChange(selected);
  };

  // Mapping options to the format expected by react-select
  const formattedOptions = options.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  // Mapping selectedOptions to the format expected by react-select
  const formattedSelectedOptions = selectedOptions.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: "200px", // Adjust the value to your desired minimum width
    }),
  };

  return (
    <Select
      options={formattedOptions}
      value={formattedSelectedOptions}
      onChange={handleChange}
      placeholder="Select status..."
      isMulti
      styles={customStyles}
    />
  );
};

export default StatusFilterDropdown;
